/* eslint react-hooks/exhaustive-deps: "warn" */


import { useRouter } from 'next/router';

import { Button } from 'ui/atoms/Button/Button';
import { Section } from 'ui/molecules/Section/Section';

import styles from './McpFinalCtaSection.module.scss';

export const McpFinalCtaSection = () => {
  const { asPath } = useRouter();

  return (
    <Section
      theme="dark"
      background="radial-gradient(ellipse 70% 130% at 50% 0%, rgba(47,86,240,0.18), transparent 70%), #17233a"
      title="Give your AI the company data it’s been guessing at."
      description="Connect the Global Database MCP server in a minute. Free to start — scale when you're ready."
      actions={
        <Button
          type="white"
          size="xl"
          href={`https://platform.globaldatabase.com/public/signup/mcp?origin=${process.env.HOST}${asPath}`}
          shadow
        >
          Start for Free
        </Button>
      }
      className={styles.section}
    />
  );
};
